export const useCheckbox = ({ onChange, disabled }) => {
  const handleChange = (e) => {
    if (disabled) return;
    if (onChange) {
      onChange(e);
    }
  };

  return {
    handleChange,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Checkbox/hooks/useCheckbox.js